import { useEffect, useState } from 'react'
import { LaunchDarkly } from '@truepill/tpos-types'
import { useClient, useFlags } from 'providers/LaunchDarklyProvider'

interface FeatureFlagsState {
  useRxClarificationStatus?: boolean
}

const initialFlagsState: FeatureFlagsState = {
  useRxClarificationStatus: false,
}

export function useInvalidRxStatusFeatureFlag(
  customerLegacyId: number | null | undefined,
): FeatureFlagsState & { loading: boolean } {
  const defaultCustomerLegacyId = '0'
  const { ldReady, ldIdentify } = useClient()
  const [flags, setFlags] = useState<FeatureFlagsState>(initialFlagsState)
  const [loading, setLoading] = useState(true)

  const { useRxClarificationStatus } = useFlags({
    useRxClarificationStatus: LaunchDarkly.FeatureFlags.USE_RX_CLARIFICATION_STATUS,
  })

  useEffect(() => {
    if (!ldReady) return
    setLoading(true)
    const updateFlags = () => {
      setFlags({
        useRxClarificationStatus,
      })
      setLoading(false)
    }

    ldIdentify(
      {
        key: customerLegacyId?.toString() ?? defaultCustomerLegacyId,
      },
      undefined,
      updateFlags,
    )
  }, [ldReady, ldIdentify, customerLegacyId, useRxClarificationStatus])

  return { ...flags, loading }
}
